import { scaleLinear } from 'd3-scale';
import type { Commons } from '../../shared/scene';

interface CommonsPanelProps {
  commons?: Commons;
}

export function CommonsPanel({ commons }: CommonsPanelProps) {
  if (!commons) return <div className="card subtle">The commons wakes up after the first human-verified submission.</div>;
  const maxTrials = Math.max(1, ...commons.byClass.map((item) => item.trials));
  const width = scaleLinear().domain([0, maxTrials]).range([8, 100]);
  return (
    <section className="commonsGrid">
      <div className="metricCard">
        <span className="metricLabel">Human trials</span>
        <strong>{commons.totalTrials}</strong>
      </div>
      <div className="metricCard">
        <span className="metricLabel">Miss rate</span>
        <strong>{Math.round(commons.missRate * 100)}%</strong>
      </div>
      <div className="card wide">
        <h3>Blind spots by anomaly class</h3>
        {commons.byClass.length ? commons.byClass.map((item) => (
          <div className="barRow" key={item.blindspotClass}>
            <span>{item.blindspotClass}</span>
            <div className="barTrack"><i style={{ width: `${width(item.trials)}%` }} /></div>
            <b>{Math.round(item.missRate * 100)}%</b>
          </div>
        )) : <p>No aggregate rows yet.</p>}
      </div>
      <div className="card">
        <h3>Load curve</h3>
        {commons.byLoad.length ? commons.byLoad.map((item) => (
          <div className="loadDot" key={item.taskLoad}>
            <span>Load {item.taskLoad}</span>
            <meter min={0} max={1} value={item.missRate}>{Math.round(item.missRate * 100)}%</meter>
            <b>{item.trials}</b>
          </div>
        )) : <p>No load curve yet.</p>}
      </div>
      {commons.nearest?.length ? (
        <div className="card wide">
          <h3>Nearest blind-spot neighbors</h3>
          <p>Cosine similarity over BGE vectors stored as JSON in D1, computed in the Worker.</p>
          {commons.nearest.map((item) => (
            <div className="neighbor" key={`${item.sceneId}-${item.blindspotClass}`}>
              <code>{item.sceneId.slice(0, 14)}</code>
              <span>{item.blindspotClass}</span>
              <b>{item.similarity.toFixed(2)}</b>
              <em>{Math.round(item.missRate * 100)}% miss</em>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
